import RequestDetail from './RequestDetail';

export default RequestDetail;
